import { useCallback } from "react";

import { useMarketingCampaignFormModelContext } from "../../../../context";

export const useVoucherPrice = () => {
	const { viewModel, onSetViewModel } = useMarketingCampaignFormModelContext();
	const { voucherPrice } = viewModel;

	const onSetVoucherPriceAmount = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "voucherPrice",
					value: {
						...voucherPrice,
						amount: {
							isEdited: true,
							value: input!,
						},
					},
				},
			]);
		},
		[onSetViewModel, voucherPrice],
	);

	return {
		voucherPrice,
		onSetVoucherPriceAmount,
	};
};
